import { handleLogoutUser } from 'redux/user/user.helpers';
import { redirectToAutoUpgrade } from 'utils/url';
import { getRandomColorCode } from './random';
import { handleErrors } from 'utils/errorHandler';
import { store } from 'redux/createStore';
import { setCurrentUser } from 'redux/user/user.actions';
import { parseStringifiedJsonObj } from 'utils/objects';

export const persistAvatars = (userIds) => {
  const avatars = JSON.parse(localStorage.getItem('avatars')) || {};
  userIds &&
    userIds.forEach((userId) => {
      if (!avatars.hasOwnProperty(userId)) {
        avatars[userId] = getRandomColorCode();
      }
    });
  localStorage.setItem('avatars', JSON.stringify(avatars));
};

export const getAvatarColor = (avatarId) => {
  const avatars = JSON.parse(localStorage.getItem('avatars'));
  return avatars && avatars[avatarId];
};

export const getCookie = (cname) => {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  if (process.env.NODE_ENV === 'production') {
    document.cookie = cname + '=' + cvalue + ';' + expires;
  } else {
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }
};

export const changePopupMsgStatusByLogout = (popupName) => {
  const status = localStorage.getItem(popupName);

  if (status === 'never') return;

  localStorage.removeItem(popupName);
};

export const changePopupMsgWithPaginationStatusByLogout = (popupName) => {
  const popupStringObj = localStorage.getItem(popupName);

  const obj = parseStringifiedJsonObj(popupStringObj);

  const status = obj?.status;

  if (status !== 'never') {
    localStorage.removeItem(popupName);
    return;
  }
};

export const clearLocalStorageAfterLogout = () => {
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('accessLevel');
  localStorage.removeItem('token');
  localStorage.removeItem('isCreatorAdmin');
  localStorage.removeItem('packageExpireBanner');
  localStorage.removeItem('SELECTED_WORKSPACE');
  // changePopupMsgStatusByLogout('updateWidgetPopup');
};

export const kickUserOutIfTokenExpired = (instance, locale) => {
  instance.interceptors.response.use(undefined, async (error) => {
    const statusCode = error?.response?.status;
    // TODO: fix later
    if (statusCode === 401 || statusCode === 403) {
      try {
        const isLoggedOut = await handleLogoutUser();
        if (isLoggedOut) {
          clearLocalStorageAfterLogout();
          // clear user state from redux
          store.dispatch(
            setCurrentUser({
              userId: '',
              containerId: '',
              createdAt: '',
              email: '',
              isLoggedIn: false,
              fullName: '',
              accessLevel: 'public',
            })
          );
          redirectToAutoUpgrade('/login');
        }
      } catch (error) {
        handleErrors(error, locale);
      }
    }

    return Promise.reject(error);
  });
};
